var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCategoryCustom = function SvgCategoryCustom(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6 16H24.4a6.55 6.55 0 0 0-6.4 6.38v55.25c0 3.4 2.99 6.37 6.4 6.37h51.2c3.41 0 6.4-2.97 6.4-6.38V22.38c0-3.4-2.99-6.37-6.4-6.37zm0 61.63H24.4V22.38h51.2zM37.2 47.88c-1.28 0-2.13.84-2.13 2.12 0 1.27.85 2.13 2.13 2.13h25.6c1.28 0 2.13-.86 2.13-2.13s-.85-2.13-2.13-2.13H37.2zm0 12.74c-1.28 0-2.13.86-2.13 2.13s.85 2.13 2.13 2.13h25.6c1.28 0 2.13-.85 2.13-2.13 0-1.27-.85-2.13-2.13-2.13zm0-25.5c-1.28 0-2.13.86-2.13 2.13s.85 2.13 2.13 2.13h17.07c1.28 0 2.13-.86 2.13-2.13s-.85-2.13-2.13-2.13z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCategoryCustom);
export default ForwardRef;